import useTeamMember, { useRelations, useTeamMemberForm } from '@hooks/useTeamMember'
import useTeamMembers from '@hooks/useTeamMembers'

import defaultRequestOptions from '@sections/Admin/packs/SystemManager/defaultRequestOptions'

import { agencyMemberRoles } from '@functions/teamMember'

import { TeamMemberModel, UserModel } from '@models/types'

const filteredAgencyMemberRolesByGroup = (user: UserModel) => {
  const groupKey = user?.actable_type === 'Agent' ? 'agent' : 'support'

  const filteredAgencyMemberRoles = agencyMemberRoles.filter(role => role.group === groupKey)
  return filteredAgencyMemberRoles
}

const useCreateOrEditAgencyTeamMemberModal = (teamMember: Partial<TeamMemberModel> = {}) => {
  const teamMemberPayload = useTeamMembers({
    filters: { team_id: teamMember.team_id },
    performHttpRequests: true,
    requestOptions: {
      // @ts-expect-error TS2783
      include_image_sizes: true,
      // @ts-expect-error TS2783
      include_user_image: true,
      ...defaultRequestOptions.teamMember,
    },
  })

  const { filteredTeamMembers, hasFilteredTeamMembers } = teamMemberPayload

  const {
    callbacks: teamMemberCallbacks,
    creating,
    updating,
  } = useTeamMember(teamMember)

  const teamMemberFormPayload = useTeamMemberForm(teamMember, { validateOn: 'change' })
  const { entityState } = teamMemberFormPayload

  const { user } = useRelations(entityState)

  // @ts-expect-error TS2345
  const allowedTeamMemberRoles = filteredAgencyMemberRolesByGroup(user)

  return (
    {
      allowedTeamMemberRoles,
      callbacks: {
        ...teamMemberCallbacks,
      },
      creating,
      filteredTeamMembers,
      hasFilteredTeamMembers,
      teamMemberFormPayload,
      updating,
    }
  )
}

export default useCreateOrEditAgencyTeamMemberModal
